import { makeStyles } from '@material-ui/core'

const styles = (isDefaultVariant) =>
  makeStyles((theme) => ({
    chatContainer: {
      position: 'relative',
      borderRadius: 20,
      paddingBlock: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      height: '100%',
      width: '100%',
    },
    defaultVariant: {
      backgroundColor: theme.palette.background.default,
      boxShadow: theme.shadows[3],
    },
    paperVariant: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.paper.border}`,
    },
    chatContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      width: '100%',
    },
    chatHeader: {
      flexShrink: 0,
      paddingRight: theme.spacing(2),
    },
    messagesContainer: {
      flexGrow: 1,
      overflow: 'hidden',
      position: 'relative',
    },
    topTransitionEffect: {
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 16,
        height: theme.spacing(2),
        background: `linear-gradient(to bottom, ${
          isDefaultVariant
            ? theme.palette.background.default
            : theme.palette.background.paper
        }, rgba(255,255,255,0))`,
        pointerEvents: 'none',
        zIndex: 1,
      },
    },
    bottomTransitionEffect: {
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 16,
        height: theme.spacing(2),
        background: `linear-gradient(to top, ${
          isDefaultVariant
            ? theme.palette.background.default
            : theme.palette.background.paper
        }, rgba(255,255,255,0))`,
        pointerEvents: 'none',
        zIndex: 1,
      },
    },
    spacingChat: {
      marginBottom: theme.spacing(2),
    },
    chatActions: {
      flexShrink: 0,
      paddingTop: 0,
      paddingRight: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  }))

export default styles
